import type { EcommerceProduct } from '../models'
import { useAnalytics } from './useAnalytics'
import { useConsent } from './useConsent'

/**
 * Фасад ecommerce-событий (ТЗ аналитики §5.4). Все методы гейтятся согласием на
 * аналитику: без него provider не инициализирован и пуши в dataLayer молча не идут
 * (двойная защита — здесь и в самом провайдере). Компоненты витрины вызывают эти
 * методы, не зная про Метрику
 */
export const useEcommerce = () => {
  const { provider } = useAnalytics()
  const { analyticsAllowed } = useConsent()

  function enabled(): boolean {
    return analyticsAllowed() && provider.initialized
  }

  return {
    impressions(products: EcommerceProduct[]) {
      if (!enabled() || products.length === 0) return
      provider.impressions(products)
    },
    detail(product: EcommerceProduct) {
      if (!enabled()) return
      provider.detail(product)
    },
    add(product: EcommerceProduct) {
      if (!enabled()) return
      provider.add(product)
    },
    remove(product: EcommerceProduct) {
      if (!enabled()) return
      provider.remove(product)
    },
    purchase(orderId: string, products: EcommerceProduct[], revenue?: number) {
      if (!enabled()) return
      provider.purchase(orderId, products, revenue)
    },
  }
}
